module.exports = __webpack_public_path__ + "static/media/Leaderboard.d516833b.png";


//////////////////
// WEBPACK FOOTER
// ./src/screenshots/Leaderboard.png
// module id = 376
// module chunks = 0